import React, { useState } from "react";
import { LinearProgress, Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';


function ProgressBar(props) {
  let files = props.files;
  console.log("the file",[files])
 
  return (
    <div style={{width: "57%"}}>
       <Box>
        { files && Array.prototype.slice.call(files).map((e) =>
        <>
        <div style={{display:"flex", justifyContent: "space-between"}}>
        <Typography  style={{size: "14px", lineHeight: "20px"}} color="common.black" fontWeight={500} >{e.name}</Typography>
        <Typography  style={{size: "14px", lineHeight: "20px"}} color="common.black" fontWeight={500} onClick={() => props.handleFileRemove(e.name)} >Cancel <CloseIcon/></Typography>
       </div>
       <LinearProgress variant="determinate" sx={{
                  backgroundColor: '#959499',
                  marginTop: "5px"
                }} value={props.uploadPercent} /><br/>
       </>
        )}
      
    </Box>
      </div>
  );
}

export default ProgressBar;